// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1ffUJ","footer":"ReportModalFilter_footer__MsLwn"};